import React from "react";
import { GridNode, HoverElement } from "../../types";
import KeyIcon from "./KeyIcon";

interface Props {
  loads: GridNode[];
  hoverElement: HoverElement | null;
  onElementHover: (element: HoverElement | null) => void;
  selectedBusId?: string | null;
  onBusSelect?: (nodeId: string) => void;
}

function LoadTable({ loads, hoverElement, onElementHover, selectedBusId, onBusSelect }: Props) {
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse" as const,
    fontSize: "12px",
    marginTop: "10px",
  };

  const thStyle = {
    background: "#f5f5f5",
    padding: "8px",
    textAlign: "left" as const,
    borderBottom: "1px solid #ddd",
    fontWeight: "bold" as const,
  };

  const tdStyle = {
    padding: "6px 8px",
    borderBottom: "1px solid #eee",
  };

  if (loads.length === 0) {
    return (
      <p style={{ padding: "20px", textAlign: "center", color: "#666" }}>
        No loads in the grid
      </p>
    );
  }

  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle} title="Show LMP curve">LMP</th>
          <th style={thStyle}>ID<KeyIcon /></th>
          <th style={thStyle}>Load (MW)</th>
          <th style={thStyle}>LMP ($/MWh)</th>
          <th style={thStyle}>Voltage (pu)</th>
          <th style={thStyle}>Position</th>
        </tr>
      </thead>
      <tbody>
        {loads.map((load) => {
          const isHighlighted = hoverElement?.type === 'Node' && hoverElement?.id === load.id;
          return (
          <tr 
            key={load.id}
            onMouseEnter={() => onElementHover({ type: 'Node', id: load.id })}
            onMouseLeave={() => onElementHover(null)}
            style={{ backgroundColor: isHighlighted ? '#FFD70030' : 'transparent' }}
          >
            <td style={{ ...tdStyle, textAlign: 'center' }}>
              <input
                type="radio"
                name="lmp-bus-select"
                checked={selectedBusId === load.id}
                onChange={() => onBusSelect?.(load.id)}
                onClick={(e) => e.stopPropagation()}
                style={{ cursor: 'pointer' }}
                title="Show LMP curve for this bus"
              />
            </td>
            <td style={tdStyle}>{load.id}</td>
            <td style={tdStyle}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="range"
                  min="-200"
                  max="0"
                  value={load.value}
                  disabled={true}
                  style={{
                    width: "80px",
                    height: "4px",
                    borderRadius: "2px",
                    background: "#ddd",
                    outline: "none",
                    cursor: "pointer",
                  }}
                />
                <span style={{ minWidth: "45px", fontSize: "11px" }}>
                  {Math.abs(load.value).toFixed(1)}
                </span>
              </div>
            </td>
            <td style={{...tdStyle, color: '#FF6600', fontWeight: 'bold'}}>
              {load.lmp !== undefined ? `$${load.lmp.toFixed(2)}` : "N/A"}
            </td>
            <td style={tdStyle}>{load.voltage?.toFixed(3) || "N/A"}</td>
            <td style={tdStyle}>
              ({load.x.toFixed(0)}, {load.y.toFixed(0)})
            </td>
          </tr>
        );
        })}
      </tbody>
    </table>
  );
}

export default LoadTable;